var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"energy-column energy-column--left"},[_c('trend-card',{ref:"trendCard",attrs:{"data":_vm.trend,"period":_vm.period}}),_c('structure-card',{ref:"structureCard",attrs:{"data":_vm.structure}}),_c('cost-card',{ref:"costCard",attrs:{"data":_vm.costs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }